/* eslint-disable max-len */
import Router, {Resource} from 'tg-resources';
import reverseUrl from 'utils/urls';

import {getCookie} from './cookie';


const api = new Router({
    /* eslint-disable no-template-curly-in-string */
    accountsUserList: new Resource(reverseUrl('api:accounts:user-list')),
    accountsWorkerAuth: new Resource(reverseUrl('api:accounts:worker-auth')),
    productionReportsProductList: new Resource(reverseUrl('api:production:reports-product-list')),
    productionSelectProductList: new Resource(reverseUrl('api:production:select-product-list')),
    productionProductList: new Resource(reverseUrl('api:production:product-list')),
    productionProductDetail: new Resource(reverseUrl('api:production:product-detail', '${pk}')),
    productionWorkLogGroupList: new Resource(reverseUrl('api:production:work-log-group-list')),
    productionWorkLogGroupDetail: new Resource(reverseUrl('api:production:work-log-group-detail', '${pk}')),
    productionWorkLogGroupAddProduct: new Resource(reverseUrl('api:production:work-log-group-add-product', '${pk}')),
    productionWorkLogGroupAddWorker: new Resource(reverseUrl('api:production:work-log-group-add-worker', '${pk}')),
    productionWorkLogGroupStopOneProduct: new Resource(
        reverseUrl('api:production:work-log-group-stop-one-product', '${pk}'),
    ),
    productionQualityControl: new Resource(reverseUrl('api:production:quality-control-list', '${product_id}')),
    productComponents: new Resource(reverseUrl('api:profit:product-components-list', '${product_id}')),
    profitArticleList: new Resource(reverseUrl('api:profit:article-list')),
    salesOrdersGenerateDocument: new Resource(reverseUrl('api:sales:order-generate-document')),
    salesOrdersLastUpdate: new Resource(reverseUrl('api:sales:order-last-update')),
    salesOrdersRefresh: new Resource(reverseUrl('api:sales:order-refresh')),
    /* eslint-enable no-template-curly-in-string */
}, {
    headers: () => ({
        Accept: 'application/json',
        'X-CSRFToken': getCookie('csrftoken'),
    }),
});

export default api;



// WEBPACK FOOTER //
// ./src/utils/api.js